var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.13,
    height: 59.001,
    viewBox: "0 0 44.13 59.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    "data-name": "Group 6",
    transform: "translate(1.429 1.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke_1",
    "data-name": "Stroke 1",
    d: "M14.27,13.809H0V0",
    transform: "translate(25.429 1.519)",
    fill: "none",
    stroke: "#ffb405",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_2",
    "data-name": "Stroke 2",
    d: "M25.859.02,0,0V55H40.1l.027-41.172Z",
    transform: "translate(0.571 0.5)",
    fill: "none",
    stroke: "#ffb405",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_3",
    "data-name": "Stroke 3",
    d: "M0,.5H23.75",
    transform: "translate(8.578 27.719)",
    fill: "none",
    stroke: "#ffb405",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_4",
    "data-name": "Stroke 4",
    d: "M0,.5H23.75",
    transform: "translate(8.578 34.941)",
    fill: "none",
    stroke: "#ffb405",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke_5",
    "data-name": "Stroke 5",
    d: "M0,.5H23.75",
    transform: "translate(8.578 42.172)",
    fill: "none",
    stroke: "#ffb405",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIc);
export default __webpack_public_path__ + "static/media/file-ic.534801ad23677e2ee54b17082fa13864.svg";
export { ForwardRef as ReactComponent };